module.exports = __webpack_public_path__ + "static/media/module8.da242382.png";